import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { LocalStorage } from 'ngx-store';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    api: string = environment.apiUrl;
    headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    isLogged: boolean;
    isAdmin: boolean;
    @LocalStorage('loggedUser') loggedUser: any;
    @LocalStorage('userData') userData: any;
    lan = localStorage.getItem('lan')

    constructor(
        private http: HttpClient,
        private router: Router) {

    }

    async login(data): Promise<any> {
        return await this.http
            .post(this.api + `/users${data.admin}/login`, data, { headers: this.headers, observe: 'response' })
            .toPromise();
    }

    async createUser(data: any): Promise<any> {
        return this.http
            .post(`${this.api}/users`, data, { headers: this.headers, observe: 'response' })
            .toPromise();
    }
    async createNoVoucherUser(data: any): Promise<any> {
      return this.http
          .post(`${this.api}/no_voucher`, data, { headers: this.headers, observe: 'response' })
          .toPromise();
  }

    async validateEmail(data: any): Promise<any> {
        return this.http
            .get(`${this.api}/users/verify/${data.token}`, { headers: this.headers, observe: 'response', responseType: 'text' })
            .toPromise();
    }

    async validateUniEmail(data: any): Promise<any> {
        return this.http
            .post(`${this.api}/usersRoles/verify/${data.token}`, data, { headers: this.headers, observe: 'response', responseType: 'text' })
            .toPromise();
    }

    async createUniUser(data: any): Promise<any> {
        return this.http
            .post(`${this.api}/usersRoles`, data, { headers: this.headers, observe: 'response' })
            .toPromise();
    }

    async getConfirmationEmail(data: any): Promise<any> {
        // console.log(data)
        return this.http
            .get(`${this.api}/users/resend-confirmation/${data.email}?language=${this.lan}`, { headers: this.headers, observe: 'response' })
            .toPromise();
    }
    async getAllCodes(): Promise<any> {
        return this.http
            .get(`${this.api}/users/otp-codes`, { headers: this.headers, observe: 'response' })
            .toPromise();
      }
      async deleteCode(otpcode): Promise<any> {
        const url = `${this.api}/users/deleteCode/${otpcode}`;
        return this.http
          .delete(url, { headers: this.headers, observe: 'response' })
          .toPromise();
      }
      async getCompletedTasks(): Promise<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
        return await this.http
          .get(this.api + `/tasks/completed_tasks`, { headers, observe: 'response' })
          .toPromise();
      }

      async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

          this.isLogged = this.loggedUser && this.userData;
          this.isAdmin = false
          const helper = new JwtHelperService();
          if (this.loggedUser && this.loggedUser.access_token) {
            const user = helper.decodeToken(this.loggedUser.access_token);
            if (user.role && user.role == "admin") this.isAdmin = true
          }

          //from this point we added a check on the logged user in order to not let him do the same task more than once

          const t = this.getCompletedTasks();

          const tasksHeDid = await t;

          let task = '';

          route.url.forEach(x => {
            task = x.path;
          });

          if (task == 'flash-beep') {
            task = 'FlashBeep'
          }
          if (task == 'personality-survey') {
            task = 'Personality'
          }
          if (task == 'memory-experiment') {
            task = 'WordCategorization'
          }
          if (task == 'loudness-perception') {
            task = 'LoudnessPerception'
          }
          if (task == 'target-detection') {
            task = 'TargetDetection'
          }
          if (task == 'questionnaire') {
            task = state.url.split('=')[1];
          }
          if (task == 'movement-perception') {
            task = 'MovementPerception'
          }
          let check = 0;

          tasksHeDid.body.forEach(x => {
            if (x == task) {
              check = 1;
            }
          })

          if (this.isLogged && !this.isAdmin && check == 0) {
            return true;
          } else {
            if (!this.isLogged) {
              alert('Please Log In')
            } else {
              if (check == 1) {
                alert('You already did this task')
              }
            }
            this.router.navigate(['']);
            return false;
          }
        }
}
